import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var warned = {};
var warnOnce = function warnOnce(message) {
  if (!warned[message]) {
    /* istanbul ignore else */
    if (typeof console !== 'undefined') {
      console.error(message); // eslint-disable-line no-console
    }

    warned[message] = true;
  }
};
var deprecated = function deprecated(propType, explanation) {
  return function (props, propName, componentName) {
    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
      warnOnce("\"".concat(propName, "\" property of \"").concat(componentName, "\" has been deprecated.\n").concat(explanation));
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  };
}; // In NODE_ENV=production the Transition.propTypes are wrapped which results in an

var _excluded$1 = ["className", "widths", "xs", "sm", "md", "lg", "xl"];

var useCol = function useCol(props) {
  var className = props.className,
      widths = props.widths,
      xs = props.xs,
      sm = props.sm,
      md = props.md,
      lg = props.lg,
      xl = props.xl,
      attributes = _objectWithoutProperties(props, _excluded$1); // Aggregate classnames for each supported width


  var colClasses = widths.map(function (sizeName, i) {
    // Get the props for the given size
    var sizeProps;

    switch (sizeName) {
      case 'xs':
        sizeProps = xs;
        break;

      case 'sm':
        sizeProps = sm;
        break;

      case 'md':
        sizeProps = md;
        break;

      case 'lg':
        sizeProps = lg;
        break;

      case 'xl':
        sizeProps = xl;
        break;
    }

    if (sizeProps || sizeProps === '') {
      var _classNames;

      var isXs = !i; // apparently the first entry is always xs??

      var nameCls = isXs ? '' : "-".concat(sizeName);
      var size = _typeof(sizeProps) === 'object' ? sizeProps.size : sizeProps;
      var valueCls = size && size !== true ? "-".concat(size) : '';
      var _sizeProps = sizeProps,
          order = _sizeProps.order,
          offset = _sizeProps.offset;
      return classNames((_classNames = {}, _defineProperty(_classNames, "col".concat(nameCls).concat(valueCls), size || size === ''), _defineProperty(_classNames, "order".concat(nameCls, "-").concat(order), order || order === 0), _defineProperty(_classNames, "offset".concat(nameCls, "-").concat(offset), offset || offset === 0), _classNames));
    }

    return null;
  });
  var computedClassName = classNames(className, colClasses.length ? colClasses : 'col');

  var result = _objectSpread2({
    className: computedClassName
  }, attributes);

  return result;
};

var _excluded = ["tag"];

var Col = function Col(props) {
  var _useCol = useCol(props),
      Tag = _useCol.tag,
      attributes = _objectWithoutProperties(_useCol, _excluded);

  return /*#__PURE__*/React.createElement(Tag, attributes);
}; // PropTypes helper


var columnPropType = PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string, PropTypes.shape({
  push: deprecated(PropTypes.oneOfType([PropTypes.number, PropTypes.string]), 'Please use the prop "order"'),
  pull: deprecated(PropTypes.oneOfType([PropTypes.number, PropTypes.string]), 'Please use the prop "order"'),
  size: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  order: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  offset: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
})]);
Col.propTypes = {
  className: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  widths: PropTypes.arrayOf(PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])),
  xs: columnPropType,
  sm: columnPropType,
  md: columnPropType,
  lg: columnPropType,
  xl: columnPropType
};
Col.defaultProps = {
  className: '',
  tag: 'div',
  widths: ['xs', 'sm', 'md', 'lg', 'xl'],
  xs: undefined,
  sm: undefined,
  md: undefined,
  lg: undefined,
  xl: undefined
};

export { columnPropType, Col as default, useCol };
//# sourceMappingURL=index.js.map
